import ServiceStore from "stores/ServiceStore";
import { RouteType } from "types/RouteType";

const PurchasingRoute: RouteType = {
  name: "Sales Orders",
  path: "/sales-orders",
  layout: "/app",
  group: "Purchasing",
  requiresAuth: true,
  hidden: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Sales Orders",
      component: () => import("./SalesOrderWorkflowHeader"),
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./SalesOrderWorkflow"),
      grayBackground: true,
    },
  },
  dialogs: [
    {
      name: "createProduct",
      component: () => import("./dialogs/CreateProductDialog"),
      title: "Create New Product",

      cancelButton: true,
      height: 600,
    },
  ],
  onEnter: async ({ rootStore }) => {
    try {
      // Data loading will be handled by the component when it mounts
      const quotesStore = rootStore.quotesStore as ServiceStore;
      const salesOrdersStore = rootStore.salesOrdersStore as ServiceStore;
      const accountsStore = rootStore.accountsStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const castingMapLayoutStore =
        rootStore.castingMapLayoutStore as ServiceStore;

      // Load data if stores exist
      if (quotesStore) quotesStore.find();
      if (salesOrdersStore) salesOrdersStore.find();
      if (accountsStore) accountsStore.find();
      if (productsStore) productsStore.find();
      if (castingMapLayoutStore) castingMapLayoutStore.find();
    } catch (error) {
      console.error("Failed to load data for sales order workflow:", error);
    }
  },
};

export default PurchasingRoute;
